interface BreadCrumbComposableDependencies {
  // Lazy lookup so the composable can reference an action defined later in the
  // store setup (calculateDriveItemsHierarchy still lives in index.ts).
  getCalculateDriveItemsHierarchy: () => (driveId: string, itemId: string) => Promise<unknown[]>;
}

export const useBreadCrumbComposable = (dependencies: BreadCrumbComposableDependencies) => {
  const calculateBreadCrumb = async (driveId: string, itemId: string) => {
    if (!driveId || !itemId) {
      return [];
    }
    const calculateDriveItemsHierarchy = dependencies.getCalculateDriveItemsHierarchy();
    return await calculateDriveItemsHierarchy(driveId, itemId);
  };

  return {
    calculateBreadCrumb
  };
};
